import React, { useState, useEffect } from 'react';
import { FiBook, FiPlay, FiStar, FiUsers } from 'react-icons/fi';
import './FlashcardsPreview.css';

const FlashcardsPreview = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  // Auto-flip animation every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFlipped(prev => !prev);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flashcards-preview">
      <div className="preview-header">
        <div className="preview-title">
          <FiBook className="preview-icon" />
          <span>Flashcards</span>
        </div>
        <div className="preview-stats">
        </div>
      </div>

      <div className="preview-content">
        <div className="sample-cards">
          {/* Sample Flashcard 1 */}
          <div className="sample-card">
            <div className="card-front">
              <div className="card-term">الشهادة</div>
              <div className="card-translation">Testimony of Faith</div>
            </div>
          </div>

          {/* Sample Flashcard 2 - Auto-flipping */}
          <div className="sample-card">
            <div className={`card-content ${isFlipped ? 'flipped' : ''}`}>
              <div className="card-front">
                <div className="card-term">الصلاة</div>
                <div className="card-translation">Prayer</div>
              </div>
              <div className="card-back">
                <div className="card-explanation">Performing the five daily prayers at set times.</div>
              </div>
            </div>
          </div>

          {/* Sample Flashcard 3 */}
          <div className="sample-card">
            <div className="card-front">
              <div className="card-term">الزكاة</div>
              <div className="card-translation">Charity</div>
            </div>
          </div>
        </div>

        <div className="preview-features">
          <div className="feature">
            <div className="feature-icon">🎯</div>
            <div className="feature-text">AI-Generated Cards</div>
          </div>
          <div className="feature">
            <div className="feature-icon">📚</div>
            <div className="feature-text">Study Mode</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashcardsPreview;
